import type {ReactElement} from 'react';
import type {PromoCarouselPaginationProps} from './promo-carousel-pagination.types';
import styles from './promo-carousel-pagination.module.scss';

/** The capsule of dots under the promo panel: one dot per slide, each jumping to its slide. */
export function PromoCarouselPagination({slideCount, activeSlideIndex, onSlideSelect}: PromoCarouselPaginationProps): ReactElement {
  const slideIndices = Array.from({length: slideCount}, (_, slideIndex) => {
    return slideIndex;
  });

  const getDotClasses = (slideIndex: number): string => {
    return slideIndex === activeSlideIndex ? `${styles.dot} ${styles.activeDot}` : styles.dot;
  };

  const getDotLabel = (slideIndex: number): string => {
    return window.i18next.t('pmwjs_show_slide_x_of_y', {current: slideIndex + 1, total: slideCount});
  };

  return (
    <div aria-label={window.i18next.t('pmwjs_slides')} className={styles.pagination} role="group">
      {slideIndices.map((slideIndex) => {
        return (
          <button
            aria-current={slideIndex === activeSlideIndex}
            aria-label={getDotLabel(slideIndex)}
            className={getDotClasses(slideIndex)}
            key={slideIndex}
            onClick={(): void => {
              onSlideSelect(slideIndex);
            }}
            type="button"
          />
        );
      })}
    </div>
  );
}
